import {Injectable} from "@angular/core";
import {Md5} from "ts-md5/dist/md5";

@Injectable()
export class Aot2JitSharingService {

  protected global = null;

  constructor() {
    if(typeof window != 'undefined') {
      this.global = window;
    }
    else if(typeof global != 'undefined') {
      this.global = global;
    }
    if(!this.global.hasOwnProperty('__aot2jit__')) {
      this.global['__aot2jit__'] = {};
    }
  }

  public getIdFromObject(instance) {

    if(typeof instance == 'object') {
      let returnValue = Md5.hashStr(instance.__proto__.constructor + '');
      return returnValue;
    }
    else if(typeof instance == 'function') {
      let returnValue = Md5.hashStr(instance + '');
      return returnValue;
    }
  }

  public addProvider(idOrProvider, provider = null) {
    let id = idOrProvider; //by default
    if(provider == null) {
      provider = idOrProvider;
      id = this.getIdFromObject(provider);
    }
    this.global['__aot2jit__'][id] = provider;
  }

  public getProvider(idOrProvider) {
    let id = idOrProvider;
    if(typeof idOrProvider != 'string') {
      id = this.getIdFromObject(idOrProvider);
    }
    if(this.global['__aot2jit__'].hasOwnProperty(id)) {
      return this.global['__aot2jit__'][id];
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/aot2jitsharing.service.ts